//
//
//
//
//
//
//

import action from './action';
import { addClickAnalytics } from 'utils/analytics';

export default {
  metaInfo: {
    title: '活动规则'
  },
  created: async function () {
    const {activityId} = this.$route.query;
    console.log(activityId)
    if(activityId){
      await this.getInfo(activityId);
    }

  },
  data() {
    return {
      info:''
    };
  },
  methods: {
    ...action,
    navToBack() {
      if (window.__wxjs_environment === 'miniprogram') {
        wx.miniProgram.navigateBack();
        addClickAnalytics({ LogTitle: `活动规则` });
      } else if (window.ReactNativeBridge) {
        addClickAnalytics({ LogTitle: `活动规则` });
        window.ReactNativeBridge.call('NAVIGATION', {
          id: '',
          params: {},
          method: 'pop',
          success: (res) => {
            console.log(res);
          },
          fail: (err) => {
            console.error(err);
          }
        });
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/module/app/fissionShareRules/page.vue